import React from "react";

function Plot_Google() {
  return (
    <div>
      <h1>Plot_Google Component</h1>
      <p>This is the Plot Google tutorial page content.</p>
    </div>
  );
}

export default Plot_Google;
